import script from "./UserStateBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserStateBadge.vue?vue&type=script&setup=true&lang=ts"

import "./UserStateBadge.vue?vue&type=style&index=0&id=5b19be1e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b19be1e"]])

export default __exports__